import { Dispatch } from "react";
import { History } from "history";
import PropertyPageDispatcher from "@Pages/PropertyPage/data/actions";
import { getLink, getPropertyFilter } from "@Pages/Search/components/SearchListItem/helper";
import { navigateWithPdpViewTransition } from "@Utils/pdpViewTransitionNav";

const handleRedirectToPropertyPage = ({
  dispatch,
  inventory,
  history,
  isDesktop,
  regionId,
  isDemoSubdomain,
  partner_uuid,
  redirectionLink = "",
  customWindowOpen,
}: {
  dispatch: Dispatch<any>;
  inventory: any;
  history: History<unknown>;
  regionId?: number;
  isDesktop: boolean;
  isDemoSubdomain: boolean;
  partner_uuid: string;
  redirectionLink?: string;
  customWindowOpen?: any;
}) => {
  const params = getPropertyFilter();
  const updatedParams: any = { ...params, ref: "search", ...(regionId && { regionId }) };
  if (isDemoSubdomain) {
    updatedParams["partner_id"] = partner_uuid;
  }

  const link = getLink(inventory, updatedParams);
  const targetLink = redirectionLink || `${link}#room_type`;

  const propertyPageDispatcher = new PropertyPageDispatcher(dispatch);
  propertyPageDispatcher.updateBasicDetails(inventory);

  if (isDesktop) {
    customWindowOpen?.({ url: targetLink, target: "_blank" });
    return;
  }

  navigateWithPdpViewTransition(() => history.push(targetLink));
};

export default handleRedirectToPropertyPage;
